import { render, staticRenderFns } from "./porfolio.vue?vue&type=template&id=0f4e0640&scoped=true"
import script from "./porfolio.vue?vue&type=script&lang=js"
export * from "./porfolio.vue?vue&type=script&lang=js"
import style0 from "./porfolio.vue?vue&type=style&index=0&id=0f4e0640&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4e0640",
  null
  
)

export default component.exports